<template>
  <div class="update-ads">
    <el-backtop target=".update-ads"></el-backtop>
    <header-top showBack haveTab></header-top>
    <!-- <div class="header-title show-back">{{headerText}}</div> -->
    <el-tabs @tab-click="handleClick" :value="tabsIndex">
      <el-tab-pane label="基本信息" name="基本信息">
        <basic></basic>
      </el-tab-pane>
      <el-tab-pane label="展位" name="展位">
        <stand v-if="tabsIndex =='展位'"></stand>
      </el-tab-pane>
      <!-- <el-tab-pane label="日志" name="日志">
        <store-log v-if="this.tabsIndex=='日志'"></store-log>
      </el-tab-pane> -->
    </el-tabs>
    
    
  </div>
</template>

<script>
import {
  getPlaceList,
  getAdsInfo,
  updateAdsInfo,
  createPlace,
  updatePlaceInfo,
  updatePlaceStatus,
  deletePlace,
} from "@/http/api/ads";

import { deepCopy } from "@/utils/deepCopy";
import { getAdsSettings, getInformationSettings } from "@/http/api/system";
import { dateFormat } from "@/common/filters";
import headerTop from "@/components/HeaderTop";
import basic from "./basic";
import stand from "./stand";
export default {
  components: {
    headerTop,
    basic,
    stand,
  },
  data() {
    return {
      id: this.$route.params.id,
      // headerText: "管理广告",
      submitLoading: false,
      isEdit: false,
      fileList: [],
      submitText: "保存",
      uploadText: "上传图片",
      AdsRules: {},
      adsTypeDic: {},
      adsInfo: {
        name: "",
        startTime: null,
        endTime: null,
        jumpUrl: "",
        sort: 0,
        more: "",
        type: "",
        file: "",
      }, // 广告对象
      tabsIndex: "基本信息",
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    
    handleClick(val) {
      this.tabsIndex = val.label;
    },
    editAds() {
      this.isEdit = !this.isEdit;
    },
    
    
    
    init() {
      getAdsInfo(this.id).then((res) => {
        this.adsInfo.name = res.result.name;
        this.adsInfo.startTime = res.result.startTime;
        this.adsInfo.endTime = res.result.endTime;
        this.adsInfo.jumpUrl = res.result.jumpUrl;
        this.adsInfo.sort = res.result.sort;
        this.adsInfo.more = res.result.more;
        this.adsInfo.type = res.result.type;
        this.adsInfo.file = res.result.file;
        this.photoUrl = res.result.imageUrl;
      });
      // this.getPlaceList();
    },
    
    getFile(item) {
      this.photoFile = item.file;
    },

    // 上传图片回调
    uploadChange(file) {
      this.photoUrl = file.url;
      this.uploadText = "更换图片";
    },

    // 管理广告
    updateAds() {
      this.$refs.AdsForm.validate((valid) => {
        if (valid) {
          let adsInfo = deepCopy(this.adsInfo);

          this.submitLoading = true;
          this.submitText = "保存中";
          var formData = new FormData();
          formData.append("Advert", JSON.stringify(adsInfo));
          if (JSON.stringify(this.photoFile) != "{}") {
            formData.append("File", this.photoFile);
          }
          updateAdsInfo(this.id, formData)
            .then((res) => {
              if (res && res.result) {
                this.$message.success({
                  message: "修改成功",
                  showClose: true,
                });
                this.submitLoading = false;
                this.submitText = "保存";
                this.$router.go(-1);
              } else {
                this.submitLoading = false;
                this.submitText = "保存";
              }
            })
            .catch((err) => {
              this.submitLoading = false;
              this.submitText = "保存";
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.update-ads {
  overflow-y: scroll;
  
  .basic-info {
    background-color: #fff;
    padding: 20px;
    text-align: left;
    min-width: 960px;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);

    .basic-item {
      .post-symbol {
        color: #f56c6c;
      }
      .basic-item-title {
        @include flex(row, center);
        justify-content: space-between;
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
        .title-btn {
          font-weight: 500;
          cursor: pointer;
          color: $--color-primary;
        }
      }

      .add-position {
        margin-bottom: 10px;
      }

      .basic-item-main {
        margin-bottom: 25px;
        padding-bottom: 15px;
        display: flex;
        border-bottom: 1px solid #ddd;

        .main-item {
          // width: 50%;

          .el-select,
          .el-input {
            width: 330px;
          }
          .basic-head {
            .basic-head-item {
              display: flex;
              align-items: flex-end;
              margin-bottom: 8px;
              line-height: 0;

              .default-img,
              .basic-head-img {
                margin-right: 10px;
                width: 143px;
                height: 148px;
              }

              .upload-btn {
                border: 1px solid rgba(221, 221, 221, 1);
                width: 110px;
                height: 30px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(0, 0, 0, 1);
              }
            }
          }
          .discount-box {
            overflow: hidden;
            padding: 15px;
            width: 500px;
            background: #f5f5f5;
            .discount-detail {
              @include flex(row, center);
              margin-bottom: 10px;
              color: #888;
              .el-input {
                width: 50%;
              }
              .el-date-editor {
                width: 50%;
              }
              span {
                margin-left: 5px;
              }
              .readonly {
                color: #c0c4cc;
              }
            }
          }
          .tips {
            margin-top: 10px;
            width: 100%;
            font-size: 12px;
            height: 13px;
            line-height: 13px;
            color: #999;
          }
          // .job-num-box {
          //   display: flex;
          //   font-size: 12px;
          //   font-weight: 400;
          //   color: rgba(0, 0, 0, 1);
          //   vertical-align: middle;

          //   p {
          //     margin: 0;
          //   }

          //   .job-num-btn {
          //     margin-left: 10px;
          //     font-size: 12px;
          //     font-weight: 400;
          //     color: $--color-primary;
          //     cursor: pointer;
          //   }
          // }

          .account-lock {
            display: inline-block;
            margin-right: 5px;
          }

          .lock-svg {
            margin-top: -2px;
          }

          .work-age {
            display: flex;
            width: 330px;

            .el-input {
              width: 50%;
              &:first-child {
                ::v-deep .el-input-group__append {
                  border-right-color: transparent;
                }
              }
            }
          }

          ::v-deep .el-form-item__content {
            .el-input-group {
              vertical-align: baseline;
            }
          }
        }

        .basic-item-right {
          padding-left: 50px;
        }

        .main-item-flex {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
      }

      .el-table {
        margin-bottom: 25px;
        .table-empty {
          color: $--color-primary;
          cursor: pointer;
        }
        .grade-box {
          display: flex;
          align-items: center;

          .grade-main {
            margin-left: 9px;
            border: 1px solid $--color-primary;
            padding: 0 5px;

            font-size: 12px;
            font-weight: 400;
            line-height: 18px;

            color: $--color-primary;
          }
        }
      }
    }

    .group-btn {
      margin-top: 5px;
      margin-left: 7rem;
    }

    ::v-deep .ads-position {
      .el-dialog__header {
        padding: 25px 25px 20px 25px;
      }

      .el-dialog__body {
        padding: 0 25px;

        .vue-treeselect__input-container {
          height: 28px;
        }

        .vue-treeselect__menu {
          width: 240px;
        }
      }

      .el-dialog__footer {
        padding: 15px 25px 25px 25px;
      }
    }
  }
  ::v-deep .el-dropdown {
    span {
      cursor: pointer;
      margin-left: 10px;
      color: $--color-primary;
    }
  }
  
}
</style>